import { ThemeProvider } from "styled-components";

export const CardThemeProvider = ({
  children,
  cardCompany,
}: {
  children: React.ReactNode;
  cardCompany: string;
}) => {
  const cardCompanyTheme: Record<string, { main: string; point: string }> = {
    카드사선택필요: {
      main: "gray",
      point: "white",
    },
    BC카드: {
      main: "rgb(222, 84, 86)",
      point: "white",
    },
    신한카드: {
      main: "white",
      point: "rgb(19, 74, 245)",
    },
    카카오뱅크: {
      main: "rgb(251, 230, 77)",
      point: "black",
    },
    현대카드: { main: "rgb(51, 51, 51)", point: "white" },
    우리카드: {
      main: "rgb(187, 223, 245)",
      point: "rgb(51, 122, 194)",
    },
    롯데카드: {
      main: "rgb(240, 240, 240)",
      point: "rgb(225, 0, 0)",
    },
    하나카드: { main: "rgb(64, 146, 143)", point: "white" },
    국민카드: {
      main: "rgb(85, 79, 71)",
      point: "rgb(247, 206, 71)",
    },
  };

  return (
    <ThemeProvider theme={cardCompanyTheme[cardCompany]}>
      {children}
    </ThemeProvider>
  );
};
